module.exports = __webpack_public_path__ + "img/sq6m_feature_01.cf3d0747.jpg";